// @ts-nocheck
import styled from 'styled-components';

export const SubHeaderStyle = styled.header`
  z-index: 1;
  .reportingSubHeader {
    &__backupDataDisclaimer {
      display: flex;
      gap: 5px;
      width: 100%;
      overflow: clip;
      z-index: 6;
      max-height: 35px;
      opacity: 1;
      background: #55ACCE;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
      text-align: center;
      line-height: 2.3rem;
      font-size: ${props => props.theme.fontSizeXS};
      transition: max-height 0.5s ease-out, opacity 0.5s ease-out;
      color: white;
      cursor: default;
      justify-content: center;
      align-items: center;
      &Msg {
        cursor: default;
        height: 100%;
        left: 0;
      }
      &CloseBtn {
        cursor: pointer;
        position: relative;
        right: inherit;
        margin-left: 8px;
        font-size: ${props => props.theme.fontSizeM};
      }
      &.hidden {
        max-height: 0;
        opacity: 0;
      }
    }
  }
`;
